module.exports = __webpack_public_path__ + "static/media/Sanika_Kulkarni.23b11617.jpg";